<template>
  <solution-sheet-item :title="title">
    <template v-for="(group, i) in pointLoadGroups">
      <solution-sheet-sub-item :key="i" :title="groupSpanText(group.span)">
        <table>
          <tbody>
            <tr>
              <td>
                <p class="solution_sheet__item__val">
                  P1: {{ group.value[0] }}kN
                </p>
              </td>
              <td>
                <p class="solution_sheet__item__val">
                  L1: {{ group.value[1] }}%
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p class="solution_sheet__item__val">
                  P2: {{ group.value[2] }}kN
                </p>
              </td>
              <td>
                <p class="solution_sheet__item__val">
                  L2: {{ group.value[3] }}%
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </solution-sheet-sub-item>
    </template>

    <template slot="illustration">
      <calc-illustration which="loadPoint" />
    </template>
  </solution-sheet-item>
</template>

<script>
import {
  SolutionSheetItem,
  SolutionSheetSubItem,
  CalcIllustration,
} from "@/components";

export default {
  components: {
    CalcIllustration,
    SolutionSheetItem,
    SolutionSheetSubItem,
  },

  props: {
    title: {
      required: true,
      default: "Título por definir",
      type: String,
    },
    pointLoadGroups: {
      required: true,
      type: Array,
    },
    hasCantilever: {
      required: true,
      type: Boolean,
    },
    modelSpansTotal: {
      required: true,
      type: Number,
    },
  },

  computed: {
    groupSpanText() {
      return (groupSpanValue) => {
        let arrOfStrs;

        if (!this.hasCantilever) {
          arrOfStrs = groupSpanValue.map((span) => {
            return `V${span}`;
          });
        } else {
          arrOfStrs = groupSpanValue.map((span) => {
            if (span === 0) {
              return `C1`;
            } else if (span === this.modelSpansTotal) {
              return `C2`;
            } else {
              return `V${span - 1}`;
            }
          });
        }

        return this.$t("Aplicado em: ") + arrOfStrs.join(", ");
      };
    },
  },

  created() {
    console.warn("Carga Pontual pointLoadGroups ->", this.pointLoadGroups);
  },
};
</script>

<style lang="scss" scoped>
</style>
